<template>
    <div class="main-index">
        <div class="main-content">
            <div class="main-left-right">
                <div class="main-left main_bgColor" style="height: 35%;">
                    <div class="main_title">碳中和</div>
                    <div class="first_div">
                        <div class="first_line">
                            <div class="first_title">实时数据 &nbsp;&nbsp;&nbsp;{{ time }}</div>
                            <div class="first_column_cnt">
                                <img src="../../../assets/image/mainIndex/first1.png" />
                                <div>实时能耗量</div>
                                <div><i>{{ tzhData.active_power }}</i>{{ tzhData.active_power_unit }}</div>
                            </div>
                            <div class="first_column_cnt">
                                <img src="../../../assets/image/mainIndex/first2.png" />
                                <div>实时标煤量</div>
                                <div><i>{{ tzhData.tce_power }}</i>{{ tzhData.tce_power_unit }}</div>
                            </div>
                            <div class="first_column_cnt">
                                <img src="../../../assets/image/mainIndex/first3.png" />
                                <div>实时碳排放耗量</div>
                                <div><i>{{ tzhData.tpf_power }}</i>{{ tzhData.tpf_power_unit }}</div>
                            </div>
                        </div>
                        <div class="first_line">
                            <div class="first_title">总数据</div>
                            <div class="first_column_cnt">
                                <img src="../../../assets/image/mainIndex/first4.png" />
                                <div>碳排放量</div>
                                <div><i>{{ tzhData.total_tpf_power }}</i>{{ tzhData.total_tpf_power_unit }}</div>
                            </div>
                            <div class="first_column_cnt">
                                <img src="../../../assets/image/mainIndex/first5.png" />
                                <div>碳减放量</div>
                                <div><i></i>吨</div>
                            </div>
                            <div class="first_column_cnt">
                                <img src="../../../assets/image/mainIndex/first6.png" />
                                <div>减排率</div>
                                <div><i></i>%</div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="main_left_cnt">
                        <div class="tanzhonghe">
                            <div class="tzh_div">碳排放量</div>
                            <div class="tzh_div"><i>7488</i>吨</div>
                        </div>
                        <div class="tanzhonghe">
                            <div class="tzh_div">碳减排量</div>
                            <div class="tzh_div"><i>2080</i>吨</div>
                        </div>
                        <div class="tanzhonghe">
                            <div class="tzh_div">减排率</div>
                            <div class="tzh_div"><i>27</i>%</div>
                        </div>
                    </div> -->
                </div>
                <div class="main-left main_bgColor" style="height: 25%;">
                    <div class="main_title">近6个月整体用电情况</div>
                    <!-- <div class="cdl_select">
                        <div :class="[yd_type == 1 ? 'title_s cdl_title' : 'title_us cdl_title']" @click="yd_click(1)">电</div>
                        <div :class="[yd_type == 2 ? 'title_s cdl_title' : 'title_us cdl_title']" style="margin-left: 0.5rem;"  @click="yd_click(2)">水</div>
                        <div :class="[yd_type == 3 ? 'title_s cdl_title' : 'title_us cdl_title']" style="margin-left: 0.5rem;"  @click="yd_click(3)">天然气</div>
                    </div> -->
                    <div class="main_left_cnt" style="height: 100% !important">
                        <v-chart :auto-resize="true" :options="firstBar" ref="firstBar" theme="ovilia-green" />
                    </div>
                </div>
                <div class="main-left main_left2 main_bgColor">
                    <div class="main_title">变压器负载率</div>
                    <div class="main_left_cnt">
                        <div class="main_left_byq">
                            <div style="top: 0%;left: 8%;">#1分配 #1变902&nbsp;<i>{{ realTransformerData['1628c53175a14c1094657e5fbe683aad'].transformer_rate }}%</i></div>
                            <div style="top: 30%;left: 4%;">#1分配 #4变905&nbsp;<i>{{ realTransformerData['191e37f359a942f9862aba87d02221d9'].transformer_rate }}%</i></div>
                            <div style="top: 60%;left: 5%;">#2分配电室901&nbsp;<i>{{ realTransformerData['9f8cac3bec214a8e9ceca5419d556cc3'].transformer_rate }}%</i></div>
                            <div style="top: 0%;left: 65%;">#2分配电室901*&nbsp;<i>{{ realTransformerData['6e50a6f36936476781e24cb984197adf'].transformer_rate }}%</i></div>
                            <div style="top: 30%;left: 66%;">#1分配 #2变903&nbsp;<i>{{ realTransformerData['910e4da63a0a40d9afe08338bfa7d68d'].transformer_rate }}%</i></div>
                            <div style="top: 60%;left: 66%;">#1分配 #3变904&nbsp;<i>{{ realTransformerData['9d97ed0be11c4b348a5364a9dadbf1de'].transformer_rate }}%</i></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="main_center">
                <div class="center_both">
                    <div class="center_nav center_nav1">
                        <div :class="[tyType == 1 ? 'center_nav_item center_nav_s center_nav_item1' : 'center_nav_item center_nav_ns center_nav_item1']" @click="clickTj(1)">
                            <img src="../../../assets/image/mainIndex/center_year.png" />
                            年数据统计
                        </div>
                        <div :class="[tyType == 2 ? 'center_nav_item center_nav_s center_nav_item1' : 'center_nav_item center_nav_ns center_nav_item1']" @click="clickTj(2)">
                            <img src="../../../assets/image/mainIndex/center_month.png" />
                            月数据统计
                        </div>
                        <div :class="[tyType == 3 ? 'center_nav_item center_nav_s center_nav_item1' : 'center_nav_item center_nav_ns center_nav_item1']" @click="clickTj(3)">
                            <img src="../../../assets/image/mainIndex/center_day.png" />
                            日数据统计
                        </div>
                    </div>
                    <div class="center_chart">
                        <div class="center_chart_item">
                            <div class="center_item_div">
                                <img src="../../../assets/image/mainIndex/shang1.png" />
                                <div class="center_item_cnt">
                                    <div><i>{{tjData[0]}}</i>&nbsp;kWh</div>
                                    <div><i>发电量</i></div>
                                </div>
                            </div>
                            <div class="center_item_div">
                                <img src="../../../assets/image/mainIndex/shang2.png" />
                                <div class="center_item_cnt">
                                    <div><i>{{tjData[1]}}</i>&nbsp;kWh</div>
                                    <div><i>上网电量</i></div>
                                </div>
                            </div>
                            <div class="center_item_div">
                                <img src="../../../assets/image/mainIndex/shang3.png" />
                                <div class="center_item_cnt">
                                    <div><i>{{tjData[2]}}</i>&nbsp;%</div>
                                    <div><i>消纳率</i></div>
                                </div>
                            </div>
                            <div class="center_item_div">
                                <img src="../../../assets/image/mainIndex/shang4.png" />
                                <div class="center_item_cnt">
                                    <div><i>{{tjData[3]}}</i>&nbsp;kWh</div>
                                    <div><i>消纳量</i></div>
                                </div>
                            </div>
                        </div>
                        <div class="center_chart_item">
                            <div class="center_item_div">
                                <img src="../../../assets/image/mainIndex/xia1.png" />
                                <div class="center_item_cnt">
                                    <div><i>{{tjData[4]}}</i>&nbsp;kWh</div>
                                    <div><i>储能调峰电量</i></div>
                                </div>
                            </div>
                            <div class="center_item_div">
                                <img src="../../../assets/image/mainIndex/xia2.png" />
                                <div class="center_item_cnt">
                                    <div><i>{{tjData[5]}}</i>&nbsp;次</div>
                                    <div><i>储能充放次数</i></div>
                                </div>
                            </div>
                            <div class="center_item_div">
                                <img src="../../../assets/image/mainIndex/xia3.png" />
                                <div class="center_item_cnt">
                                    <div><i>{{tjData[6]}}</i>&nbsp;kWh</div>
                                    <div><i>充电桩充电量</i></div>
                                </div>
                            </div>
                            <div class="center_item_div">
                                <img src="../../../assets/image/mainIndex/xia4.png" />
                                <div class="center_item_cnt">
                                    <div><i>{{tjData[7]}}</i>&nbsp;次</div>
                                    <div><i>充电桩充电次数</i></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="center_both main_bgColor">
                    <div class="main_title" style="width: 40%">发电量对比</div>
                    <div class="center_nav center_nav2">
                        <div class="center_nav_item center_nav_ns center_nav_item2">
                            <img src="../../../assets/image/mainIndex/fdl_xia1.png" />
                            <div class="item2_div">
                                <div>去年</div>
                                <div><i>389万</i>&nbsp;kWh</div>
                            </div>
                        </div>
                        <div class="center_nav_item center_nav_ns center_nav_item2">
                            <img src="../../../assets/image/mainIndex/fdl_xia2.png" />
                            <div class="item2_div">
                                <div>今年</div>
                                <div><i>400万</i>&nbsp;kWh</div>
                            </div>
                        </div>
                        <div class="center_nav_item center_nav_ns center_nav_item2">
                            <img src="../../../assets/image/mainIndex/fdl_xia3.png" />
                            <div class="item2_div">
                                <div>增长率</div>
                                <div><i>3.1</i>%</div>
                            </div>
                        </div>
                    </div>
                    <div class="center_chart">
                        <v-chart :auto-resize="true" :options="centerBar" ref="centerBar" theme="ovilia-green" />
                    </div>
                </div>
            </div>
            <div class="main-left-right">
                <div class="main-left main_bgColor" style="height: 15%">
                    <div class="main_title">充电桩</div>
                    <div class="main_left_cnt cdz_pad" style="height: fit-content">
                        <div class="cdz_div">
                            <img src="../../../assets/image/mainIndex/cdz1.png" />
                            <div class="cdz_div_cnt">
                                <div>正在充电（个）</div>
                                <div><i>10/10</i></div>
                            </div>
                        </div>
                        <div class="cdz_div">
                            <img src="../../../assets/image/mainIndex/cdz1.png" />
                            <div class="cdz_div_cnt">
                                <div>本月月充电次数</div>
                                <div><i>198</i>&nbsp;次</div>
                            </div>
                        </div>
                        <!-- <div class="cdz_div">
                            <img src="../../../assets/image/mainIndex/cdz1.png" />
                            <div class="cdz_div_cnt">
                                <div>本月充电收益</div>
                                <div><i>17424</i>&nbsp;元</div>
                            </div>
                        </div>
                        <div class="cdz_div">
                            <img src="../../../assets/image/mainIndex/cdz1.png" />
                            <div class="cdz_div_cnt">
                                <div>累计充电收益</div>
                                <div><i>21.5</i>&nbsp;万元</div>
                            </div>
                        </div> -->
                    </div>
                </div>
                <div class="main-left main_bgColor" style="height: 43%;">
                    <div class="main_title">充电桩充电量</div>
                    <div class="cdl_select">
                        <div :class="[cdl_type == 1 ? 'title_s cdl_title' : 'title_us cdl_title']" @click="cdl_click(1)">9L1</div>
                        <div :class="[cdl_type == 2 ? 'title_s cdl_title' : 'title_us cdl_title']" style="margin-left: 0.5rem;"  @click="cdl_click(2)">9L2</div>
                    </div>
                    <div class="main_left_cnt" style="height: calc(100% - 4rem) !important">
                        <v-chart auto-resize :options="areaLine" ref="chart" theme="ovilia-green" />
                    </div>
                </div>
                <div class="main-left main_left4 main_bgColor">
                    <div class="main_title">储能-各月充放电量对比</div>
                    <div class="main_left_cnt">
                        <v-chart :auto-resize="true" :options="lastBar" ref="lastBar" theme="ovilia-green" />
                        <!-- <div class="bz_div"><i>储能的充放电次数:</i>121<i>次</i></div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import "echarts/lib/chart/bar";
import "echarts/lib/chart/line";
import "echarts/lib/component/title";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/markPoint";
import * as api from "@/http/api.js";
import moment from "moment";
export default {
    data() {
        return {
            cdl_type: 1,
            yd_type: 1,
            light_x: [],
            light_y: [],
            last_line_y: [],
            center_line_y: [],
            first_y: [],
            first_y1: ['105', '85', '135', '120', '105'],
            first_y2: ['120', '105', '105', '135', '85'],
            first_y3: ['85', '135', '120', '105', '105'],
            tyType: 1, //1年数据统计 2月数据统计 3日数据统计
            tyData: [],
            tjYearData: ['400万', '12万', '97', '388万','4.27万','730','15万','2008'],
            tjMonthData: ['33万', '9000', '97.3', '32.1万','1.1万','60','1.05万','212'],
            tjDayData: ['1万', '280', '97.2', '9720','391','2','528','11'],
            cdl_list: [],
            cdl_list1: [6000, 7000, 10000, 9000, 8000, 6000, 8000, 3000, 4000],
            cdl_list2: [4000, 3000, 8000, 6000, 8000, 8000, 10000, 7000, 6000],
            time: '',
            tzhData: {},
            realMonthData: {},
            realTransformerData: {},
        };
    },
    created() {
        this.initData();
        // this.getSysDate();
    },
    methods: {
        initData() {
            this.getRealCarbon();
            this.getRealMonthData();
            this.getRealTransformerData();
            this.light_x = ['2022-03', '2022-04', '2022-05', '2022-06', '2022-07', '2022-08', '2022-09', '2022-10', '2022-11', '2022-12', '2023-01', '2023-02'];
            this.light_y = this.getRandom(12);
            this.ping_y = this.getRandom(12);
            this.gu_y = this.getRandom(12);
            this.last_line_y = this.getRandom(12);
            this.center_qunian_y = [23, 19, 32, 28, 35, 38, 37, 41, 28, 30, 27, 9];
            this.center_jinnian_y = [25, 20, 35, 30, 40, 45, 40, 46, 33, 35, 30, 10];
            this.center_line_y = [9, 11, 9, 7, 14, 18, 11, 12, 18, 17, 11, 11];
            this.first_y = this.first_y1;
            this.tjData = this.tjYearData;
            this.cdl_list = this.cdl_list1;
            this.time = moment().format('YYYY-MM-DD')
        },
        getRealTransformerData() {
            api.getRealTransformerData().then(res => {
                if (res && res.error_code == 0) {
                    this.realTransformerData = res.bus_json;
                }
            });
        },
        getRealMonthData() {
            api.getRealMonthData({point_id: '000001'}).then(res => {
                if (res && res.error_code == 0) {
                    this.realMonthData = res.bus_json;
                }
            });
        },
        getRealCarbon() {
            api.getRealCarbon({point_id: '000001'}).then(res => {
                if (res && res.error_code == 0) {
                    this.tzhData = res.bus_json;
                }
            });
        },
        clickTj(type) {
            this.tyType = type;
            if(type == 1) this.tjData = this.tjYearData
            else if(type == 2) this.tjData = this.tjMonthData
            else this.tjData = this.tjDayData
        },
        yd_click(type) {
            this.yd_type = type;
            if(type == 1) this.first_y = this.first_y1
            else if(type == 2) this.first_y = this.first_y2
            else this.first_y = this.first_y3
        },
        cdl_click(type) {
            this.cdl_type = type;
            if(type == 1) this.cdl_list = this.cdl_list1
            else this.cdl_list = this.cdl_list2
        },
        getRandom(num) {
            let arr = [];
            for (let i = 0; i < num; i++) {
                var random1 = (Math.random() * (150)).toFixed(2);
                arr.push(random1)
            }
            return arr;
        },
        getSysDate() {
            api.getSysDate1().then(res => {
                if (res && res.error_code == 0) {
                    this.getCurrentElecList(res.bus_json.sysdate3);
                    this.getCurrentMonthsFdl(res.bus_json.sysdate3);
                }
            });
        },
    },
    computed: {
        areaLine() {
            const option = {
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "cross",
                        label: {
                            backgroundColor: "#6a7985"
                        }
                    }
                },
                // legend: {
                //     orient: "horizontal",
                //     // icon: "circle",
                //     // top: 10,
                //     itemHeight: 10,
                //     itemWidth: 10,
                //     data: [
                //         {
                //             name: "充电量",
                //             textStyle: {
                //                 color: "#fff",
                //                 fontSize: 10
                //             }
                //         }
                //     ]
                // },
                grid: {
                    left: "5%",
                    right: "4%",
                    top: "15%",
                    bottom: "5%",
                    containLabel: true
                },
                xAxis: [
                    {
                        type: "category",
                        boundaryGap: false,
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#999999"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        },
                        data: ['2022-06', '2022-07', '2022-08', '2022-09', '2022-10', '2022-11', '2022-12', '2023-01', '2023-02']
                    }
                ],
                yAxis: [
                    {
                        name: "单位:kWh",
                        type: "value",
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: "#999999" // 颜色
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        },
                        nameTextStyle: {
                            color: "#999999",
                            //    padding: 10,
                            fontSize: 10
                        },
                         splitLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: '充电量',
                        type: "line",
                        // name: this.quxian.legendData[0],
                        label: {
                            normal: {
                                show: false,
                                position: "top"
                            }
                        },
                        smooth: true,
                        symbolSize: 0.1,
                        itemStyle: {
                            normal: {
                                color: '#00c1de',
                                shadowBlur: 8,
                                shadowColor: '#25d5f0',
                                borderColor: '#00c1de',
                                borderWidth: 2,
                                backgroundColor: 'transparent'
                            }
                        },
                        areaStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#00729B'
                                }, {
                                    offset: 1,
                                    color: '#0E7388'
                                }]),
                            }
                        },
                        data: this.cdl_list,
                        markPoint: {
                            data: [
                                {type: 'max', name: '最大值'}
                            ]
                        }
                    }
                ]
            };
            return option;
        },
        lastBar() {
            const option = {
                grid: {
                    left: "5%",
                    right: "3%",
                    bottom: "10%",
                    top: "20%",
                    containLabel: true
                },
                color: ["#1593CE", "#CE720b"],
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow"
                    }
                },
                legend: {
                    orient: "horizontal",
                    // icon: "circle",
                    // top: 10,
                    itemHeight: 10,
                    itemWidth: 10,
                    data: [
                        {
                            name: "去年",
                            textStyle: {
                                color: "#fff",
                                fontSize: 10
                            }
                        },
                        {
                            name: "今年",
                            textStyle: {
                                color: "#fff",
                                fontSize: 10
                            }
                        },
                        {
                            name: "增长率",
                            textStyle: {
                                color: "#fff",
                                fontSize: 10
                            }
                        }
                    ]
                },
                xAxis: [
                    {
                        type: "category",
                        axisTick: { show: false },
                        data: ['2022-06', '2022-07', '2022-08', '2022-09', '2022-10', '2022-11', '2022-12', '2023-01', '2023-02'],
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#999999"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        name: "单位：kWh",
                        type: "value",
                        min:0,  //取0为最小刻度
                        max: 20000,
                        nameTextStyle: {
                            color: "#999999",
                            fontSize: 10
                        },
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#999999"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        },
                        splitLine: {
                            show: false,
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        }
                    },
                    {
                        name: "单位：%",
                        type: "value",
                        min:0,  //取0为最小刻度
                        max: 15,
                        nameTextStyle: {
                            color: "#999999",
                            fontSize: 10
                        },
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#999999"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: "去年",
                        type: "bar",
                        barWidth: 8,
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#06B4F9'
                                }, {
                                    offset: 1,
                                    color: '#092856'
                                }]),
                                barBorderRadius: [10, 10, 0, 0]
                            }
                        },
                        barGap: 0,
                        label: 111,
                        data: [8900, 11000, 12000, 9500, 7000, 10000, 9000, 10000, 9000],
                    },
                    {
                        name: "今年",
                        type: "bar",
                        barWidth: 8,
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#8CCFA5'
                                }, {
                                    offset: 1,
                                    color: '#1F924A'
                                }]),
                                barBorderRadius: [10, 10, 0, 0]
                            }
                        },
                        label: 222,
                        data: [10200, 12000, 12500, 9800, 8000, 11000, 10000, 11000, 9500],
                    },
                    {
                        name: '增长率',
                        type: 'line',
                        yAxisIndex: 1,
                        itemStyle: {  /*设置折线颜色*/
                            normal: {
                                color: '#F8B551'
                            }
                        },
                        data: [15, 9, 4, 3, 14, 10, 11, 10, 6]
                    }
                ]
            };
            return option;
        },
        centerBar() {
            const option = {
                grid: {
                    left: "1%",
                    right: "3%",
                    bottom: "10%",
                    top: "20%",
                    containLabel: true
                },
                color: ["#1593CE", "#CE720b"],
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow"
                    }
                },
                legend: {
                    orient: "horizontal",
                    // icon: "circle",
                    // top: 10,
                    itemHeight: 12,
                    itemWidth: 12,
                    data: [
                        {
                            name: "去年",
                            textStyle: {
                                color: "#fff",
                                fontSize: 12
                            }
                        },
                        {
                            name: "今年",
                            textStyle: {
                                color: "#fff",
                                fontSize: 12
                            }
                        },
                        {
                            name: "增长率",
                            textStyle: {
                                color: "#fff",
                                fontSize: 12
                            }
                        }
                    ]
                },
                xAxis: [
                    {
                        type: "category",
                        axisTick: { show: false },
                        data: this.light_x,
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#999999"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        name: "单位：万kWh",
                        type: "value",
                        min:0,  //取0为最小刻度
                        max: 90,
                        nameTextStyle: {
                            color: "#999999",
                            fontSize: 10
                        },
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#999999"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        },
                        splitLine: {
                            show: false,
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        }
                    },
                    {
                        name: "单位：%",
                        type: "value",
                        min:0,  //取0为最小刻度
                        max: 18,
                        nameTextStyle: {
                            color: "#999999",
                            fontSize: 10
                        },
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#999999"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: "去年",
                        type: "bar",
                        barWidth: 10,
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#06B4F9'
                                }, {
                                    offset: 1,
                                    color: '#092856'
                                }]),
                                barBorderRadius: [10, 10, 0, 0]
                            }
                        },
                        barGap: 0,
                        label: 111,
                        data: this.center_qunian_y,
                    },
                    {
                        name: "今年",
                        type: "bar",
                        barWidth: 10,
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#8CCFA5'
                                }, {
                                    offset: 1,
                                    color: '#1F924A'
                                }]),
                                barBorderRadius: [10, 10, 0, 0]
                            }
                        },
                        label: 222,
                        data: this.center_jinnian_y,
                    },
                    {
                        name: '增长率',
                        type: 'line',
                        yAxisIndex: 1,
                        itemStyle: {  /*设置折线颜色*/
                            normal: {
                                color: '#F8B551'
                            }
                        },

                        data: this.center_line_y
                    }
                ]
            };
            return option;
        },
        firstBar() {
            const options = {
                // 坐标轴
                grid: {
                    top: "0%",
                    left: "5%",
                    right: "13%",
                    bottom: "7%",
                    containLabel: true, //是否包含坐标轴的文字
                },
                // X轴：横向柱状图，将xAxis的type设置为value
                xAxis: {
                    name: '万kWh',
                    type: "value",
                    nameTextStyle: {
                        color: "#fff",
                        fontSize: 10
                    },
                    axisLabel: {
                        //x轴文字的配置
                        show: true,
                        textStyle: {
                            color: "#fff",
                            fontSize: 10
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            color: "" // 颜色
                        }
                    },
                    splitLine: {
                        lineStyle: {
                            color: "" // 颜色
                        }
                    }
                },
                // Y轴：横向柱状图，将xAxis的type设置为category
                yAxis: {
                    type: "category",
                    data: this.realMonthData.show_month,
                    nameTextStyle: {
                        color: "#fff",
                        fontSize: 10
                    },
                    axisLabel: {
                        //x轴文字的配置
                        show: true,
                        textStyle: {
                            color: "#fff",
                            fontSize: 10
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            color: "" // 颜色
                        }
                    },
                    splitLine: {
                        lineStyle: {
                            color: "" // 颜色
                        }
                    }
                },
                // 图表内容
                series: [
                    {
                        type: "bar", // 图表类型
                        data: this.realMonthData.datalist, // 数据
                        barWidth: 8, // 柱的宽度
                        // 柱上面的数值配置
                        label: {
                            show: true, // 显示值
                            position: "right", // 显示位置
                            color: "white",
                            fontSize: 10
                        },
                        // 每一个条目的样式配置
                        itemStyle: {
                            barBorderRadius: [0, 34, 34, 0], // 圆角
                            // 渐变色  1、指明颜色渐变的方向  2、指明不同百分比之下颜色的值
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                                { offset: 0, color: "#1DA68C" },
                                { offset: 1, color: "#137EAA" },
                            ]),
                        },
                    },
                ],
            };
            return options;
        },
    }
};
</script>
<style lang="scss">
.main-index {
    width: 100%;
    height: calc(100% + #{px2Rem(45px)} + 5rem - 3.5rem);

    .main-content {
        width: 100%;
        height: 100%;
        // background-image: url("../../../assets/image/mainIndex/back.png");
        // background-size: auto 80%;
        text-align: center;
        background-repeat: no-repeat;
        background-position: top center;
        padding: 0 1rem;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;

        .first_div {
            width: 100%; 
            margin-top: 4%;
            height: 46%;
            // display: flex; 
            // align-items:center;
            .first_line {
                width: 100%;
                height: 100%;
                display: inline-flex; 
                align-items: center;
                justify-content: space-between;
                position: relative;
                .first_title {
                    position: absolute;
                    top: 0;
                    left: 1rem;
                    height: 1.9rem;
                    width: 80%;
                    background: url("../../../assets/image/mainIndex/inner_title.png") no-repeat;
                    background-size: 100% 100%;
                    line-height: 1.9rem;
                    font-size: 0.65rem;
                    color: #fff;
                    text-align: left;
                    text-indent: 2.5rem;
                }
            }
            .first_column_cnt {
                display: inline-flex; 
                flex-flow: column wrap; 
                align-items:center;
                justify-content: space-around; 
                flex: 1;
                color: #fff;
                margin-top: 0.6rem;
                img {
                    width: 4rem;
                }
                div {
                    font-size: 0.65rem;
                    margin-top: 0.25rem;
                }
            }
        }
        .main-left-right {
            width: 23%;
            height: 100%;
            display: flex;
            flex-flow: column nowrap;
            justify-content: space-around;
        }

        .main_center {
            width: 51%;
            display: inline-flex;
            flex-flow: column nowrap;
            justify-content: space-around;

            .center_both {
                height: 46%;
                display: inline-flex;
                flex-flow: row nowrap;
                position: relative;

                .center_nav2 {
                    width: 14%;
                    //    margin-right: 2%;

                    div {
                        font-size: 0.7rem;
                    }

                    img {
                        width: 1.5rem;
                        margin-left: 0.3rem;
                    }
                }

                .center_nav1 {
                    width: 18%;
                    margin-right: 2%;

                    img {
                        width: 1.5rem;
                        margin-right: 0.6rem;
                    }
                }

                .center_nav {
                    display: inline-flex;
                    flex-flow: column nowrap;
                    justify-content: space-around;

                    .center_nav_item {
                        color: #fff;
                        font-size: 0.8rem;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        margin-right: 0.6rem;
                        cursor: pointer;
                        .item2_div {
                            flex: 1;
                            display: inline-flex;
                            flex-flow: column nowrap;
                            height: 100%;
                            justify-content: space-evenly;
                        }
                    }
                    .center_nav_ns {
                        background: url("../../../assets/image/mainIndex/center_ns.png") no-repeat;
                        background-size: 100% 100%;
                    }
                    .center_nav_s {
                        background: url("../../../assets/image/mainIndex/center_s.png") no-repeat;
                        background-size: 100% 100%;
                    }
                    .center_nav_item1 {
                        height: 15%;
                    }

                    .center_nav_item2 {
                        height: 12%;
                    }
                }

                .center_chart {
                    flex: 1;

                    .echarts {
                        width: 100%;
                        height: 100%;
                    }

                    .center_chart_item {
                        width: 100%;
                        height: 50%;
                        background: url("../../../assets/image/mainIndex/ban.png") no-repeat;
                        background-size: 100% auto;
                        background-position: bottom;
                        display: inline-flex;
                        flex-flow: row wrap;
                        justify-content: space-around;

                        .center_item_div {
                            width: 17%;
                            height: 80%;
                            position: relative;

                            img {
                                width: 100%;
                                height: 100%;
                            }

                            .center_item_cnt {
                                position: absolute;
                                bottom: 37%;
                                left: 0;
                                width: 80%;
                                margin: 0 10%;

                                div {
                                    width: 100%;
                                    color: #fff;
                                    height: 1.3rem;
                                    line-height: 1.3rem;
                                    font-size: 0.75rem;

                                    &:first-child i {
                                        font-size: 0.85rem;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        .main_title {
            position: absolute;
            top: -1rem;
            left: 0;
            height: 2rem;
            width: 80%;
            background: url("../../../assets/image/mainIndex/main_title.png") no-repeat;
            background-size: 100% 100%;
            line-height: 2rem;
            font-size: 0.8rem;
            color: #fff;
            text-align: left;
            text-indent: 2rem;
        }

        .main_bgColor {
            background-color: rgb(7, 19, 19, 0.6);
        }

        .left-title {
            color: #fff;
            text-align: left;
            padding: 0.4rem 0 0 2.8rem;
            font-size: 0.8rem;
        }

        .right-title {
            color: #fff;
            text-align: right;
            padding: 0.4rem 2.8rem 0 0;
            font-size: 0.8rem;
        }

        .main_left1 {
            height: 20%;
        }

        .main_left2 {
            height: 31%;
        }

        .main_left3 {
            height: 25%;
        }

        .main_left4 {
            height: 31%;
        }

        .main-left {
            // height: 10rem;
            // background: url("../../../assets/image/mainIndex/l1.png") no-repeat;
            // background-size: 100% 100%;
            // margin-bottom: 1rem;
            width: 100%;
            position: relative;

            .main_left_cnt {
                width: 100%;
                height: calc(100% - 1rem);
                margin-top: 1rem;
                display: inline-flex;
                flex-flow: row wrap;
                justify-content: space-around;
                position: relative;
                .bz_div {
                    position: absolute;
                    bottom: 0;
                    left: 50%;
                    color: #fff;
                    font-size: 0.7rem;
                    text-align: center;
                    transform: translate(-50%, 0);
                }
                .echarts {
                    width: 100%;
                    height: 100%;
                }

                .tanzhonghe {
                    width: 25%;
                    background: url("../../../assets/image/mainIndex/tanzhonghe.png") no-repeat;
                    background-size: 100% auto;
                    background-position: center;
                    position: relative;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;
                    color: #fff;

                    .tzh_div {
                        width: 100%;
                        font-size: 0.65rem;
                        height: 0.8rem;
                        line-height: 0.8rem;
                    }
                }

                .main_left_byq {
                    width: 100%;
                    height: 70%;
                    margin-top: 10%;
                    background: url("../../../assets/image/mainIndex/bianyaqi.png") no-repeat;
                    background-size: auto 100%;
                    background-position: center;
                    position: relative;

                    div {
                        position: absolute;
                        color: #fff;
                        font-size: 0.7rem;
                    }
                }

                .cdz_div {
                    width: 50%;
                    height: 50%;
                    display: inline-flex;
                    box-sizing: border-box;
                    padding: 1rem 0 1rem 0.6rem;
                    align-items: center;

                    img {
                        width: 3.8rem;
                        height: 3.8rem;
                    }

                    .cdz_div_cnt {
                        height: 3.8rem;
                        color: #fff;
                        font-size: 0.8rem;
                        flex: 1;
                        display: inline-flex;
                        flex-flow: column wrap;
                        justify-content: space-around;
                        text-align: left;
                        margin-left: 0.2rem;
                        div:last-child i {
                            font-size: 0.9rem;
                        }
                    }
                }
            }
            .cdl_select {
                width: 100%; 
                display: inline-flex;
                align-items: center;
                margin-top: 1.5rem;
                color: #fff;
                justify-content: center;
                cursor: pointer;
                .cdl_title {
                    width: 3.5rem;
                    height: 1.2rem;
                    line-height: 1.2rem;
                }
                .title_us {
                    background: url("../../../assets/image/mainIndex/index_us.png") no-repeat;
                    background-size: 100% 100%;
                }
                .title_s {
                    background: url("../../../assets/image/mainIndex/index_s.png") no-repeat;
                    background-size: 100% 100%;
                }
            }
            .cdz_pad {
                box-sizing: border-box;
              //  padding: 0.6rem;
            }

            .left1-content {
                display: flex;
                height: 8rem;
                width: 100%;
                font-size: 0.8rem;
                padding: 0.2rem 0.6rem;
                box-sizing: border-box;
                color: #fff;

                .left1-content-item {
                    flex: 1;

                    .left1-item-title {
                        height: 3rem;
                        margin-bottom: 1rem;

                        img {
                            width: 3rem;
                            height: 3rem;
                        }
                    }

                    .left1-item-content {
                        .left1-item-content-item {
                            height: 1.6rem;
                            text-align: center;
                            padding-left: 0rem;
                            box-sizing: border-box;

                            img {
                                margin-right: 0.3rem;
                            }

                            span {
                                color: #5ae9ed;
                            }
                        }
                    }
                }
            }

            .left2-chart {
                width: 100%;
                height: 8rem;

                .echarts {
                    width: 100%;
                    height: 100%;
                }
            }

            .left3-chart {
                width: 100%;
                height: 8rem;

                .echarts {
                    width: 100%;
                    height: 100%;
                }
            }

            .right1-content {
                width: 100%;
                height: 7rem;
                padding: 0.5rem 2rem;
                box-sizing: border-box;
                display: flex;
                justify-content: space-between;

                .right1-item {
                    width: 6rem;
                    height: 6rem;
                    background: url("../../../assets/image/mainIndex/circle.png") no-repeat;
                    background-size: 100% 100%;
                    font-size: 0.8rem;

                    .right1-item-title {
                        color: #fff;
                        height: 3rem;
                        line-height: 4rem;
                    }

                    .right1-item-content {
                        color: #e1cd57;
                        line-height: 1rem;

                        span {
                            color: #fff;
                        }
                    }
                }
            }

            .right2-chart {
                width: 100%;
                height: 9rem;

                .echarts {
                    width: 100%;
                    height: 100%;
                }
            }

            .right2-data {
                color: #7bc7f3;
                font-size: 0.8rem;
                height: 1rem;
                line-height: 1rem;
                font-weight: bold;
                margin-top: 0.4rem;

                span {
                    color: #a5cf8f;
                }
            }

            .right3-content {
                width: 100%;
                height: 8rem;
                padding: 0.5rem 2rem;
                box-sizing: border-box;
                font-size: 1rem;

                .right3-box {
                    width: 100%;
                    height: 4rem;
                    display: flex;

                    .right3-item {
                        width: 50%;
                        padding: 0.5rem;
                        box-sizing: border-box;
                        text-align: center;

                        .right3-item-title {
                            width: 100%;
                            line-height: 1.5rem;
                            color: #fff;
                        }

                        .right3-item-content {
                            width: 100%;
                            line-height: 1.5rem;
                            color: #73bae3;

                            span {
                                color: #fff;
                            }
                        }
                    }
                }
            }
        }

        i {
            color: #00ffff;
        }
    }
}
</style>
